import {create} from './create';
import * as set from './set';
import * as validate from './validate';
import {getPrice} from './getPrice';
import {getSubComponentsTotal} from './getSubComponentsTotal';
export default {
    create,
    set,
    validate,
    getPrice,
    getSubComponentsTotal
}